import React, { useRef, useState } from 'react';

const ImageUploader = ({ onImageSelect }) => {
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState('');
  const [inputKey, setInputKey] = useState(Date.now()); // Key to reset input

  const fileInputRef = useRef();

  const handleFile = (file) => {
    if (file && file.type.startsWith('image/')) {
      setPreview(URL.createObjectURL(file));
      setFileName(file.name);
      onImageSelect(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
    // Reset input value so same file can be selected again if needed
    e.target.value = '';
  };

  const handleRemove = () => {
    setPreview(null);
    setFileName('');
    onImageSelect(null);
    setInputKey(Date.now()); // Reset input
  };

  return (
    <div className="space-y-4 w-full">
      {/* Drop Zone */}
      <div
        className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center bg-gray-50 hover:bg-gray-100 cursor-pointer"
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => fileInputRef.current?.click()}
      >
        <p className="text-gray-500">Click or drag an image to upload</p>
        <input
          key={inputKey}
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleChange}
          className="hidden"
        />
      </div>

      {/* Preview + Remove */}
      {preview && (
        <div className="flex items-center gap-4">
          <div className="relative w-[50px] h-[50px]">
            <img
              src={preview}
              alt="Preview"
              className="w-full h-full object-cover rounded border shadow"
            />
            <button
              type="button"
              onClick={handleRemove}
              className="absolute -top-2 -right-2 bg-white text-red-600 border border-gray-300 rounded-full w-6 h-6 flex items-center justify-center shadow hover:bg-red-50"
              title="Remove image"
            >
              ×
            </button>
          </div>
          <span className="text-sm text-gray-700">{fileName}</span>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
